export default class ControllerBringSymbolsToFront {
  constructor(container) {
    this.container = new PIXI.Container();
    container.addChild(this.container);

    this.reelsMap = new Map();
  }

  bringToFront(symbol) {
    if (symbol.parent === this.container) return;

    if (!this.reelsMap.has(symbol.parent)) {
      this.reelsMap.set(symbol.parent, []);
    }

    this.reelsMap.get(symbol.parent).push(symbol);

    const animationSymbolPosition = this.container.toLocal({ x: 0, y: 0 }, symbol);
    symbol.x = animationSymbolPosition.x;
    symbol.y = animationSymbolPosition.y;
    this.container.addChild(symbol);
  }

  bringAllBack() {
    for (let [reel, symbols] of this.reelsMap) {
      symbols.forEach(symbol => {
        const animationSymbolPosition = reel.toLocal({ x: 0, y: 0 }, symbol);
        symbol.x = animationSymbolPosition.x;
        symbol.y = animationSymbolPosition.y;
        reel.addChild(symbol);
      });
    }

    this.reelsMap.clear();
  }
}
